import store from '@/store'
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const routerPush = Router.prototype.push 
Router.prototype.push = function push (location) {
    return routerPush.call(this, location).catch(err => err)
}

const index = ()=>  import('@/components/Index')
const cata = ()=>  import('@/components/Catalogue')
const datail = ()=>  import('@/components/Datail')
const detail = ()=>  import('@/components/Detail')
const search = ()=>  import('@/components/Search')
const bom = ()=>  import('@/components/Bom')
const login = ()=>  import('@/components/Login')
const register = ()=>  import('@/components/Register')
const Retrieve = ()=>  import('@/components/Retrieve')

const about = ()=>  import('@/components/about/about')
const aboutus = ()=>  import('@/components/about/aboutus')
const Agreement = ()=>  import('@/components/about/Agreement')
const Contactus = ()=>  import('@/components/about/Contactus')
const Invoice = ()=>  import('@/components/about/Invoice')
const CompanyNews = ()=>  import('@/components/about/CompanyNews')
const ProductNews = ()=>  import('@/components/about/ProductNews')
const Disclaimers = ()=>  import('@/components/about/Disclaimers')
const Complaint = ()=>  import('@/components/about/Complaint')

const test = ()=>  import('@/components/Test')

const brand = ()=>  import('@/components/Brand')
const news = ()=>  import('@/components/about/news')


const rou = [
    { path:'/',component:index,meta:{show:true,cate:true}},
    { path:'/cata',component:cata,meta:{show:true,title:'商品目录'}},
    { path:'/datail/:id',component:datail,props:true,meta:{show:true,title:'商品目录'}},
    { path:'/detail/:id',component:detail,props:true,meta:{show:true}},
    { path:'/search',component:search,props:true,meta:{show:true}},
    { path:'/bom',component:bom,meta:{show:true,title:'BOM配单'}},
    { path:'/about',component:about,
        children:[
            {
                path:'Disclaimers',
                component:Disclaimers
                ,meta:{show:true,title:'免责声明'}
            },
            {
                path:'Complaint',
                component:Complaint
                ,meta:{show:true,title:'投诉通道'}
            },
            {
                path:'aboutus',
                component:aboutus
                ,meta:{show:true,title:'关于我们'}
            },
            {
                path:'Agreement',
                component:Agreement
                ,meta:{show:true,title:'用户协议'}
            },
            {
                path:'Contactus',
                component:Contactus
                ,meta:{show:true,title:'联系我们'}
            },
            {
                path:'Invoice',
                component:Invoice
                ,meta:{show:true,title:'发票须知'}
            },
            {
                path:'CompanyNews',
                component:CompanyNews
                ,meta:{show:true,title:'企业动态'}
            },
            {
                path:'ProductNews',
                component:ProductNews
                ,meta:{show:true,title:'产品动态'}
            },
            {
                path:'news/:id',
                component:news,
                props:true,
                meta:{show:true,visiable:true},
            },
        ],meta:{show:true}
        
    },
    { path:'/login',component:login,meta:{title:'登录'}},
    { path:'/register',component:register,meta:{title:'注册'}},
    { path:'/retrieve',component:Retrieve},
    { path:'/test',component:test},
    { path:'/brands/:id',component:brand,props:true,meta:{show:true}},
    { path:'*',redirect:'/',meta:{show:true}}  //不匹配的路由、转到/路由
]

const router = new Router({
    routes:rou,     //注意：属性名是routes
    scrollBehavior (to, from, savedPosition) {
        return { y: 0 }
    },
    mode:'hash' //http://localhost:8080/#/a   加井号  默认
    // mode:'history' //http://localhost:8080/a  不加井号
})
const defaultTitle = '深圳市毅创腾电子科技有限公司';

router.beforeEach((to,from,next)=>{
    let token = store.state.user.token;
    document.title = to.meta.title ? to.meta.title : defaultTitle;
    if(token){
        if(to.path == '/login' || to.path == '/register'){
            next('/');
        } else {
            next();
        }
    } else {
        next();
    }
});


export default router